import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/lab-procedures/stoolculture";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	stoolculture: {
		id: "ktx.stoolculture.title",
		defaultMessage: "Széklettenyésztés"
	},
	result: {
		id: "ktx.stoolculture.field.result",
		defaultMessage: "Eredmény"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.result }] }]
};

export const node: LeafNode = {
	id: "ktx_stoolculture",
	value: {
		schemaId: "stoolculture",
		title: messages.stoolculture,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
